import { getStackProps, Stack, StackProps } from '@/ui/Stack';

type Props = {
  width: string;
  showArrow?: boolean;
} & StackProps;

const ManIllustrationSvg = ({ width, height, showArrow, ...props }: Props) => {
  return (
    <Stack
      {...getStackProps(props)}
      width={width}
      height={height}
      overflow="hidden"
    >
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 488 314"
        preserveAspectRatio="xMidYMin slice"
        width="100%"
        height="100%"
      >
        <path
          d="m297.207 51.24-28.911 37.275c-2.852 3.645-7.249 5.87-11.88 5.96l-30.014.773 3.182-28.73 25.358.52 31.275-35.188c3.694-4.09 9.731-4.985 14.392-2.02l8.867 5.552"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m400.358 109.371-92.285 25.975-25.975-92.285 8.288-2.33 7.752 5.714a7.546 7.546 0 0 0 10.018-.905 7.606 7.606 0 0 0 .39-9.992l65.744-18.464 26.068 92.287Z"
          fill="#9EC7DB"
          stroke="#9EC7DB"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m374.891 48.076-76.99 21.651 2.255 8.02 76.991-21.65-2.256-8.02Z"
          stroke="#fff"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m324.2 62.256-15.367 4.407 16.379-17.626 6.435-6.812 8.93 2.498 23.198 6.494-15.365 4.314-24.21 6.725ZM312.59 74.18l-8.02 2.256 12.204 43.396 8.02-2.255L312.59 74.18Z"
          stroke="#fff"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m312.346 121.083 2.226-9.213 2.243 8.008-4.469 1.205ZM334.329 106.324l-11.851 3.332 2.255 8.02 11.851-3.333-2.255-8.019ZM354.879 100.521l-12.475 3.508 2.255 8.02 12.476-3.508-2.256-8.02ZM374.657 95.01l-11.852 3.333 2.255 8.02 11.852-3.333-2.255-8.02ZM389.359 99.424l-4.471 1.297-2.243-8.009 6.714 6.712ZM332.42 68.58l-8.02 2.255 12.204 43.396 8.02-2.256-12.204-43.396Z"
          stroke="#fff"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m372.749 57.267-8.02 2.256 12.203 43.396 8.02-2.256-12.203-43.396ZM352.829 62.893l-8.019 2.255 12.203 43.396 8.02-2.255-12.204-43.396ZM352.734 93.025l-12.48 3.54M372.57 87.413l-11.92 3.367M332.246 98.808l-11.825 3.275"
          stroke="#fff"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m305.452 32.892 1.914 1.521c.455.38.908.852 1.269 1.322a7.606 7.606 0 0 1-.39 9.992c-2.649 2.723-6.917 3.19-10.018.905l-7.753-5.714M254.941 67.039l1.421 7.436"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M86.16 69.865a4.402 4.402 0 0 0 .926 4.906l7.22 7.498 8.332 8.609-.278 3.24-8.98-.648-74.7-5.647 5.647-74.978.648-8.702 83.679 6.295-4.628 60.723-8.794-2.777-3.702-1.11c-2.13-.648-4.444.462-5.37 2.591Z"
          stroke="#9EC7DB"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M86.16 69.866a4.402 4.402 0 0 0 .927 4.906l7.22 7.498-.833 11.293-.648 8.701-83.68-6.294 6.294-83.68 8.98.648 74.7 5.646-3.795 49.986-3.703-1.11c-2.221-.834-4.535.277-5.461 2.406Z"
          stroke="#9EC7DB"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m90.974 26.545-3.147 41.377c-.74.463-1.296 1.11-1.666 2.036a4.402 4.402 0 0 0 .925 4.906l.278.278-2.684 35.175L1 104.023l6.294-83.68 83.68 6.202Z"
          fill="#9EC7DB"
          stroke="#9EC7DB"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m163.453 112.446-14.625 26.289c-6.295 7.405-18.05 6.016-22.586-2.592L102.73 90.971l-.092-.093-8.331-8.609-6.943-7.22-.278-.278c-1.296-1.295-1.573-3.24-.925-4.906.37-.833.925-1.573 1.666-2.036 1.11-.74 2.5-.926 3.795-.555l3.703 1.11 8.794 2.777.648-8.145 30.176 47.579 7.59-11.016 20.92 12.867ZM134.943 110.78l-4.258 7.405"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M70.517 77.826c-.092 4.166-3.517 7.498-7.683 7.59.093-2.498-1.203-4.627-2.962-4.813-1.944-.185-3.702 1.76-4.073 4.536l-6.48-.37c.186-2.592-1.11-4.814-2.961-4.999-1.944-.185-3.796 1.852-4.073 4.629l-6.11-.37v-.278c.278-2.777-1.018-5.184-2.962-5.37-1.944-.184-3.795 1.852-4.073 4.63v.74l-4.72-.278 5.738-42.766 24.068 1.296-2.592 17.588 15.829 11.94c1.944 1.297 3.147 3.703 3.054 6.295Z"
          stroke="#fff"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.176 83.658v.278c-.37 2.592-2.129 4.443-3.98 4.258-1.759-.185-3.055-2.222-2.962-4.628v-.74c.277-2.778 2.129-4.814 4.073-4.63 1.85.279 3.147 2.685 2.87 5.462ZM49.32 84.676v.37c-.278 2.777-2.129 4.814-4.073 4.629-1.944-.185-3.24-2.592-2.962-5.369.278-2.777 2.129-4.813 4.073-4.628 1.851.185 3.147 2.406 2.962 4.998ZM62.835 85.417v.462c-.278 2.777-2.13 4.814-4.073 4.629-1.944-.185-3.24-2.592-2.962-5.369v-.093c.37-2.684 2.129-4.72 4.073-4.535 1.758.277 3.054 2.406 2.962 4.906ZM52.837 50.982l-7.775-.555M51.542 59.313l-7.498-.37M52.004 59.498l15.274-8.516c2.406-1.388 3.054-4.628 1.203-6.757-1.944-2.314-5.554-2.037-7.22.463l-9.257 14.81Z"
          stroke="#fff"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M232.508 288.692h-30.084l-13.422-119.781-11.201 119.781h-32.12l17.773-147.18h52.577l16.477 147.18Z"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M245.282 95.414h-24.53v50.078c-38.878 9.164-60.723 0-60.723 0v-27.307c-12.96-2.962-20.18-17.865-20.18-17.865l12.311-22.864c2.5-4.72 6.665-8.238 11.664-9.997l16.384-5.739c0 2.777 1.111 5.276 2.869 7.128 1.759 1.85 4.258 3.054 6.943 3.147 6.109.277 11.108-4.721 10.83-10.923l43.414 5.461c8.053 16.662 1.018 28.881 1.018 28.881Z"
          fill="#009FDF"
        />
        <path
          d="M245.282 95.414h-24.53v50.078c-38.878 9.164-60.723 0-60.723 0v-27.307c-12.96-2.962-20.18-17.865-20.18-17.865l12.311-22.864c2.5-4.72 6.665-8.238 11.664-9.997l16.384-5.739c0 2.777 1.111 5.276 2.869 7.128 1.759 1.85 4.258 3.054 6.943 3.147 6.109.277 11.108-4.721 10.83-10.923l43.414 5.461c8.053 16.662 1.018 28.881 1.018 28.881Z"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m207.7 44.595-7.683 3.703.741 12.866c.37 6.11-4.721 11.2-10.83 10.923-2.777-.092-5.184-1.296-6.943-3.147-1.759-1.851-2.869-4.35-2.869-7.128V31.451l-9.535-5.554c-1.666-1.018-2.499-2.962-1.944-4.814.556-1.85 2.222-3.147 4.166-3.147.185 0 .463 0 .648.093l12.867 1.944v-6.017l14.903-4.906 10.922 22.308c2.592 4.814.556 10.83-4.443 13.237Z"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m177.801 288.692-2.314 23.974h-53.133l23.142-22.216.185-1.758h32.12ZM256.945 312.666h-51.837l-2.684-23.974h30.084l24.437 23.974ZM178.449 18.677V10.53c0-2.962 3.24-4.814 5.832-3.425l1.203.648 1.666-4.258c.926-2.407 3.796-3.24 5.925-1.759l2.314 1.666c2.684-2.221 6.757 0 6.294 3.518l-.277 2.129-14.904 4.906v6.017l-8.053-1.296Z"
          fill="#009FDF"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m396.474 27.909 7.557-16.326M402.959 32.208l14.115-11.099M405.308 39.57l17.828-2.504M205.201 169.189h13.885M160.121 169.189h12.311"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M190.946 80.788a1.481 1.481 0 1 0 0-2.962 1.481 1.481 0 0 0 0 2.962ZM190.946 91.896a1.481 1.481 0 1 0 0-2.962 1.481 1.481 0 0 0 0 2.962Z"
          fill="#fff"
          stroke="#fff"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m174.284 22.287 5.924 2.036M160.029 118.185V95.414M220.752 95.414v-8.979M202.053 18.955l2.315 4.998-.833 1.666"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M197.24 21.915a.37.37 0 1 0 0-.738.37.37 0 0 0 0 .738Z"
          fill="#009FDF"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M202.516 29.6c-.277.185-.648.37-1.018.462-1.759.37-3.517-.648-3.888-2.314"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M194.571 18.793c.868-.868 1.395-1.747 1.178-1.964-.217-.217-1.096.31-1.963 1.178-.868.868-1.395 1.747-1.178 1.964.216.217 1.096-.31 1.963-1.178ZM192.241 51.445l7.776-3.147.37 6.202-8.146-3.055Z"
          fill="#009FDF"
          stroke="#009FDF"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m148.273 294.431-13.885-20.827c-2.592-3.888-8.516-3.24-10.182 1.203-1.018 2.592.092 5.646 2.499 7.035l21.568 12.589ZM148.088 294.523l-15.551 1.204c-2.962.185-4.351 3.702-2.499 5.924 1.11 1.388 3.054 1.666 4.628.833l13.422-7.961ZM232.508 293.783l13.885-20.828c2.592-3.887 8.516-3.239 10.182 1.204 1.018 2.592-.092 5.646-2.499 7.035l-21.568 12.589ZM232.693 293.875l15.551 1.203c2.962.186 4.351 3.703 2.499 5.925-1.111 1.388-3.054 1.666-4.628.833l-13.422-7.961Z"
          stroke="#9EC7DB"
          strokeWidth="1.851"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {showArrow && (
          <>
            <path
              d="m468.313 170.398 4.613-10.81-10.809-4.613"
              stroke="#009FDF"
              strokeWidth="1.77"
              strokeLinecap="round"
            />
            <path
              d="M369.5 135.5c34 39 74.75 36.047 101.997 24.932"
              stroke="#009FDF"
              strokeWidth="1.77"
              strokeLinecap="round"
            />
          </>
        )}
      </svg>
    </Stack>
  );
};

export { ManIllustrationSvg };
